import React, { useState } from 'react';
import {
  ITableColumnFieldsFragment,
  JoinConditionOperator,
} from '../../../../utils/apollo/graphqlSchema';
import DataModelerEditJoinPair from './DataModelerEditJoinPair';

interface IProps {
  isEditMode: boolean;
  factViewKey: string;
  isSubjectInitial: boolean;
  switchToTemporal: (() => void) | null;
  factFieldKey: string | undefined;
  setFactFieldKey: (fieldKey: string, isSubject: boolean) => void;
  relOp: JoinConditionOperator;
  setRelOp: (newOp: JoinConditionOperator) => void;
  dimViewKey: string;
  dimTableKey: string;
  dimTableColumn: string | undefined;
  setDimTableColumn: (column: string, isSubject: boolean) => void;
  availableColumnsFromServer: ITableColumnFieldsFragment[];
  remove?: () => void;
  isLast: boolean;
}

const DataModelerEditExistingJoinPair = ({
  isEditMode,
  isSubjectInitial,
  switchToTemporal,
  factViewKey,
  factFieldKey,
  setFactFieldKey,
  relOp,
  setRelOp,
  dimViewKey,
  dimTableKey,
  dimTableColumn,
  setDimTableColumn,
  availableColumnsFromServer,
  remove,
  isLast,
}: IProps) => {
  const [isSubject, setIsSubject] = useState(isSubjectInitial);
  return (
    <DataModelerEditJoinPair
      isLast={isLast}
      isEditMode={isEditMode}
      isSubject={isSubject}
      setIsSubject={setIsSubject}
      switchToTemporal={switchToTemporal}
      factViewKey={factViewKey}
      factFieldKey={factFieldKey}
      setFactFieldKey={setFactFieldKey}
      relOp={relOp}
      setRelOp={setRelOp}
      dimViewKey={dimViewKey}
      dimTableKey={dimTableKey}
      dimTableColumn={dimTableColumn}
      setDimTableColumn={setDimTableColumn}
      availableColumnsFromServer={availableColumnsFromServer}
      remove={remove}
    />
  );
};

export default DataModelerEditExistingJoinPair;
